import {OverlayTrigger, Tooltip} from "react-bootstrap";

// @ts-expect-error legacy
import Formatter from "@/legacy/Formatter.js";

export interface WFItem {
  sendingRequest: number;
  dns: number;
  connectSecureConnection: number;
  connect: number;
  requestSending: number;
  waitingResponse: number;
  downloadingData: number;
  url: string;
  status: string;
  resourceType: string;
  size: number;
  duration: number;
  pct: {
    requestStart: number;
    requestDuration: number;
    waitStart: number;
    waitDuration: number;
    receiveStart: number;
    receiveDuration: number;
  };
}

const WFTooltip = ({wf}: {wf: WFItem}) => {
  const _ms = Formatter.ms;
  return (
    <div>
      <strong>Request Timing</strong>
      <br />
      <strong>Requesting: {_ms(wf.sendingRequest)}</strong>
      <br />
      <span>DNS: {_ms(wf.dns)}</span>
      <br />
      <span>
        Connect: {_ms(wf.connect)} (SSL: {_ms(wf.connectSecureConnection)})
      </span>
      <br />
      <span>Sending request: {_ms(wf.requestSending)})</span>
      <br />
      <strong>Server processing: {_ms(wf.waitingResponse)}</strong>
      <br />
      <strong>Downloading response: {_ms(wf.downloadingData)}</strong>
    </div>
  );
};

export const WaterfallRow = ({wf}: {wf: WFItem}) => {
  const _ms = Formatter.ms;
  return (
    <tr>
      <td>
        <span title={`${wf.url}`}>{Formatter.truncate(wf.url, 45)}</span>
      </td>
      <td>{wf.status || "not completed"}</td>
      <td>{wf.resourceType || "n/a"}</td>
      <td>{Formatter.humanBytes(wf.size) || "n/a"}</td>
      <td>
        <OverlayTrigger
          placement="top"
          overlay={(props) => (
            <Tooltip {...props}>
              <WFTooltip wf={wf} />
            </Tooltip>
          )}
        >
          <span>{_ms(wf.duration)}</span>
        </OverlayTrigger>
      </td>
      <td className="position-relative">
        <span
          className="wf-request"
          title={`Requesting ${_ms(wf.sendingRequest)}`}
          data-bs-toggle="tooltip"
          style={{left: `${wf.pct.requestStart}%`, width: `${wf.pct.requestDuration}%`}}
        />
        <span
          className="wf-wait"
          title={`Server processing ${_ms(wf.waitingResponse)}`}
          data-bs-toggle="tooltip"
          style={{left: `${wf.pct.waitStart}%`, width: `${wf.pct.waitDuration}%`}}
        />
        <span
          className="wf-receive"
          title={`Downloading response ${_ms(wf.downloadingData)}`}
          data-bs-toggle="tooltip"
          style={{left: `${wf.pct.receiveStart}%`, width: `${wf.pct.receiveDuration}%`}}
        />
        &nbsp;
      </td>
    </tr>
  );
};
